// Environment: server

// Route String
export default '/blog/@slug'
